import { render, staticRenderFns } from "./edit-sidebar-dynamic.vue?vue&type=template&id=1889dfc4&scoped=true&"
import script from "./edit-sidebar-dynamic.vue?vue&type=script&lang=js&"
export * from "./edit-sidebar-dynamic.vue?vue&type=script&lang=js&"
import style0 from "./edit-sidebar-dynamic.vue?vue&type=style&index=0&id=1889dfc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889dfc4",
  null
  
)

export default component.exports